<template>
  <a-modal
    :title="title"
    :visible="value"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
    :bodyStyle="{ paddingRight: '110px' }"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      layout="horizontal"
    >
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="课程名称" prop="name">
            <a-input v-model="form.name" placeholder="请输入课程名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="描述" prop="description">
            <a-textarea v-model="form.description" placeholder="请输入描述" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 16 }"
            label="难度级别"
            prop="level"
          >
            <a-select
              v-model="form.level"
              placeholder="请输入难度级别"
              showSearch
              allowClear
            >
              <a-icon
                type="close-circle"
                slot="clearIcon"
                style="font-size: 15px;"
                theme="twoTone"
              />
              <a-select-option
                :value="item"
                v-for="(item, i) in levels"
                :key="'level' + i"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 16 }"
            label="课程类型"
            prop="categoryId"
          >
            <a-select v-model="form.categoryId">
              <a-select-option
                v-for="item in categories"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 16 }"
            label="讲师"
            prop="teacher"
          >
            <a-input v-model="form.teacher" placeholder="请输入讲师名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="封面" prop="tempIcon">
            <IconUpload v-model="form.tempIcon" :imageUrl="form.icon" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="附件" prop="tempAttach">
            <DraggerUpload
              v-model="form.tempAttach"
              :oldFiles="form.attachs"
              @remove="onRemove"
              :max="10"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import uploadChannel from '@/core/upload_channel'
import {
  addCourse,
  updateCourse,
  getCourseById,
  getCategories
} from '@/api/course/course'
import IconUpload from '@/components/Upload/IconUpload'
import DraggerUpload from '@/components/Upload/DraggerUpload'
import { uploadMulti } from '@/api/upload'

export default {
  components: { IconUpload, DraggerUpload },
  mixins: [uploadChannel],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Object,
      default: () => ({
        type: 'add',
        id: undefined
      })
    },
    afterSubmit: {
      type: Function,
      default: function() {}
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      confirmLoading: false,
      levels: ['高手进阶', '新手入门'],
      categories: [],
      form: {
        name: undefined,
        description: undefined,
        level: '高手进阶',
        period: undefined,
        multiple: true,
        icon: undefined,
        attachs: undefined,
        tempIcon: undefined,
        tempAttach: [],
        categoryId: undefined,
        teacher: undefined
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'change'
          }
        ],
        description: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'change'
          }
        ],
        level: [
          {
            required: true,
            message: '请输入难度级别',
            trigger: 'change'
          }
        ],
        categoryId: [
          {
            required: true,
            message: '请输入类型',
            trigger: 'blur'
          }
        ],
        tempIcon: [
          {
            required: false
          }
        ],
        tempAttach: [
          {
            required: false
          }
        ],
        teacher: [
          {
            required: false,
            message: '请输入讲师名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    title() {
      let { mode } = this
      if (mode.type === 'add') {
        return '新增课程'
      } else {
        return '修改课程'
      }
    }
  },
  watch: {
    mode(m) {
      if (m.type === 'update') {
        getCourseById(m.id).then(res => {
          let result = res.result
          Object.keys(this.form).forEach(key => {
            this.form[key] = result[key]
          })
        })
      }
    },
    value(val) {
      if (val) {
        getCategories().then(res => {
          if (res.code === 200) {
            let result = res.result
            this.categories = result
          }
        })
      }
    }
  },
  methods: {
    resetForm() {
      this.$refs.ruleForm.resetFields()
      this.form.icon = undefined
      this.form.attachs = undefined
    },
    handleOk() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const { form, mode } = this
          this.confirmLoading = true
          try {
            let iconArr = form.tempIcon && [form.tempIcon]
            const [icons, attachs] = await Promise.all([
              uploadMulti(iconArr, null, { dir: 'course' }),
              uploadMulti(form.tempAttach, null, { dir: 'course' })
            ])
            let values = { ...form }
            if (icons && icons.length > 0) {
              values.icon = icons[0].url
            }
            if (attachs && attachs.length > 0) {
              let newAttachs = attachs.map(item => {
                return {
                  fileId: item.id,
                  name: item.name,
                  url: item.url
                }
              })
              values.attachs = values.attachs || []
              values.attachs = values.attachs.concat(newAttachs)
            }
            let resp = {}
            if (mode.type === 'add') {
              resp = await addCourse(values)
            } else {
              resp = await updateCourse(mode.id, values)
            }
            const type = mode.type === 'add' ? '增加' : '修改'
            if (resp.code === 200) {
              this.$notification['success']({
                message: '成功',
                description: `课程 ${form.name} ${type}成功`
              })
            }
            this.resetForm()
            this.$emit('input', false)
            let { afterSubmit } = this
            afterSubmit && afterSubmit()
          } catch (err) {
            this.$notification['error']({
              message: '失败',
              description: `${err}`
            })
          } finally {
            this.confirmLoading = false
          }
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.resetForm()
      this.$emit('input', false)
    },
    // 删除旧附件
    onRemove(id) {
      let { form } = this
      let index = form.attachs.findIndex(item => item.id === id)
      form.attachs.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped></style>
